import ParticipantCard from './ParticipantCard';
export default ParticipantCard;
